import React from 'react';
import { MapPin, BookOpen, Lock, Gift, Sparkles } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function RecipeMenu() {
  const {
    t
  } = useLanguage();
  const regions = [{
    name: 'Oaxaca',
    subtitle: t('recipeMenu.oaxacaSub'),
    color: '#3E2723',
    accent: '#FACC15',
    recipes: ['Mole Enchiladas', 'Yellow Mole (Amarillito)', 'Hacienda-Style Tlayuda', 'Squash Vine Soup']
  }, {
    name: 'Baja & Cabo',
    subtitle: t('recipeMenu.bajaSub'),
    color: '#14B8A6',
    accent: '#FBF7F0',
    recipes: ['Baja Fish Tacos', 'Tuna Tostadas', 'Tableside Guacamole', 'Classic Ceviche']
  }, {
    name: 'Tulum',
    subtitle: t('recipeMenu.tulumSub'),
    color: '#C2410C',
    accent: '#FACC15',
    recipes: ['Cochinita Pibil', 'Chicken Pibil Sliders', 'Street-Style Mexican Esquites', 'Panuchos']
  }];
  return <section className="w-full py-16 md:py-24 bg-[#F5F1E8]" data-id="element-385">
      <div className="max-w-6xl mx-auto px-6 md:px-12" data-id="element-386">
        <div className="text-center mb-12" data-id="element-387">
          <div className="inline-flex items-center gap-2 bg-[#C2410C] text-white px-4 py-1.5 rounded-full text-xs font-extrabold uppercase tracking-wider mb-4" data-id="element-388">
            <BookOpen className="w-3.5 h-3.5" data-id="element-389" />
            {t('recipeMenu.badge')}
          </div>
          <h2 className="text-4xl md:text-5xl text-[#3E2723] mb-4" data-id="element-390">
            {t('recipeMenu.title')}{' '}
            <span className="italic text-[#C2410C]" data-id="element-391">
              {t('recipeMenu.titleItalic')}
            </span>
          </h2>
          <p className="text-xl text-[#3E2723]/70 max-w-2xl mx-auto" data-id="element-392">
            {t('recipeMenu.desc')}
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 md:gap-8" data-id="element-393">
          {regions.map(region => <div key={region.name} className="bg-white rounded-2xl shadow-xl overflow-hidden border border-[#3E2723]/10 flex flex-col" data-id="element-394">
              <div className="p-6 text-white text-center" style={{
            backgroundColor: region.color
          }} data-id="element-395">
                <div className="inline-flex items-center gap-1.5 text-xs uppercase tracking-[0.2em] font-bold mb-2" style={{
              color: region.accent
            }} data-id="element-396">
                  <MapPin className="w-3.5 h-3.5" data-id="element-397" />
                  {t('recipeMenu.region')}
                </div>
                <h3 className="text-3xl md:text-4xl leading-tight" style={{
              fontFamily: 'DM Serif Display, serif'
            }} data-id="element-398">
                  {region.name}
                </h3>
                <p className="text-sm italic mt-1 text-white/85" data-id="element-399">
                  {region.subtitle}
                </p>
              </div>

              <div className="p-6 flex-1 flex flex-col" data-id="element-400">
                <ul className="space-y-4 flex-1" data-id="element-401">
                  {region.recipes.map((recipe, idx) => <li key={recipe} className="flex items-baseline gap-3" data-id="element-402">
                      <span className="text-xs font-extrabold flex-shrink-0 w-6" style={{
                  color: region.color
                }} data-id="element-403">
                        0{idx + 1}
                      </span>
                      <span className="flex-1 text-[#3E2723] font-medium leading-snug" data-id="element-404">
                        {recipe}
                      </span>
                      <span className="flex-1 border-b border-dotted border-[#3E2723]/20 mb-1 mx-1" aria-hidden="true" data-id="element-405"></span>
                      <span className="text-xs uppercase tracking-wider text-[#3E2723]/40 font-bold" data-id="element-406">
                        {t('recipeMenu.recipe')}
                      </span>
                    </li>)}
                </ul>

                <div className="mt-6 pt-4 border-t border-[#3E2723]/10 text-center" data-id="element-407">
                  <span className="inline-block text-xs uppercase tracking-[0.2em] font-bold" style={{
                color: region.color
              }} data-id="element-408">
                    {t('recipeMenu.footer')}
                  </span>
                </div>
              </div>
            </div>)}
        </div>

        <div className="mt-10" data-id="element-409">
          <div className="relative bg-[#3E2723] rounded-2xl overflow-hidden shadow-2xl border-4 border-yellow-300" data-id="element-410">
            <div className="absolute -top-12 -right-12 w-48 h-48 bg-[#C2410C]/30 rounded-full blur-3xl pointer-events-none" data-id="element-411"></div>
            <div className="absolute -bottom-12 -left-12 w-48 h-48 bg-[#EC4899]/20 rounded-full blur-3xl pointer-events-none" data-id="element-412"></div>

            <div className="relative grid md:grid-cols-[1fr_auto] gap-6 items-center p-6 md:p-8" data-id="element-413">
              <div data-id="element-414">
                <div className="inline-flex items-center gap-2 bg-yellow-300 text-[#3E2723] px-3 py-1 rounded-full text-xs font-extrabold uppercase tracking-widest mb-4" data-id="element-415">
                  <Sparkles className="w-3.5 h-3.5" data-id="element-416" />
                  {t('recipeMenu.bonusBadge')}
                </div>

                <div className="inline-flex items-center gap-2 bg-green-500/15 border border-green-400/40 text-green-300 px-3 py-1.5 rounded-lg text-xs md:text-sm font-bold mb-4 ml-2" data-id="element-417">
                  {t('recipeMenu.bonusIncluded')}
                </div>

                <h3 className="text-3xl md:text-4xl text-white leading-tight mb-3" style={{
                fontFamily: 'DM Serif Display, serif'
              }} data-id="element-418">
                  {t('recipeMenu.bonusTitle')}{' '}
                  <span className="text-yellow-300 italic" data-id="element-419">
                    {t('recipeMenu.bonusTitleItalic')}
                  </span>
                </h3>

                <p className="text-white/80 text-base md:text-lg leading-relaxed mb-5" data-id="element-420">
                  {t('recipeMenu.bonusDesc1')}{' '}
                  <span className="text-yellow-300 font-bold" data-id="element-421">
                    {t('recipeMenu.bonusDesc2')}
                  </span>
                </p>

                <div className="space-y-2 mb-6" data-id="element-422">
                  <div className="flex items-center gap-3 text-white" data-id="element-423">
                    <Lock className="w-4 h-4 text-yellow-300 flex-shrink-0" data-id="element-424" />
                    <span className="text-sm md:text-base" data-id="element-425">
                      <strong className="text-yellow-300" data-id="element-426">
                        {t('recipeMenu.hidden1Title')}
                      </strong>{' '}
                      <span className="text-white/70 italic" data-id="element-427">
                        {t('recipeMenu.hidden1Desc')}
                      </span>
                    </span>
                  </div>
                  <div className="flex items-center gap-3 text-white" data-id="element-428">
                    <Lock className="w-4 h-4 text-yellow-300 flex-shrink-0" data-id="element-429" />
                    <span className="text-sm md:text-base" data-id="element-430">
                      <strong className="text-yellow-300" data-id="element-431">
                        {t('recipeMenu.hidden2Title')}
                      </strong>{' '}
                      <span className="text-white/70 italic" data-id="element-432">
                        {t('recipeMenu.hidden2Desc')}
                      </span>
                    </span>
                  </div>
                </div>

                <p className="text-yellow-300 text-sm font-bold italic" data-id="element-433">
                  {t('recipeMenu.curious')}
                </p>
              </div>

              <div className="flex justify-center md:justify-end" data-id="element-434">
                <a href="#offer" className="inline-flex items-center gap-2 bg-[#C2410C] hover:bg-[#9A3412] text-white px-6 py-4 rounded-xl text-base font-extrabold uppercase tracking-wide shadow-lg border-2 border-yellow-300 transition-all hover:scale-105 whitespace-nowrap" data-id="element-435">
                  <Gift className="w-5 h-5" data-id="element-436" />
                  {t('recipeMenu.unlockBtn')}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}